import { del, get, post } from "../common/apiClient";

const PATH_CLASS = "/class";

const getClasses = async (pageNumber, limit = 6, searchQuery = "") => {
  const params = new URLSearchParams({
    page: String(pageNumber),
    limit: String(limit),
  });

  if (searchQuery) {
    params.set("q", searchQuery);
  }

  return await get(`${PATH_CLASS}?${params.toString()}`);
};

const insertOrUpdateClass = async (body) => {
  return await post(PATH_CLASS, body);
};

const deleteClass = async (classId) => {
  return await del(`${PATH_CLASS}/${classId}`);
};

const getClassMembers = async (classId) => {
  return await get(`${PATH_CLASS}/${classId}/members`);
};

const addStudentToClass = async (classId, userId) => {
  return await post(`${PATH_CLASS}/${classId}/members`, { userId });
};

const removeStudentFromClass = async (classId, userId) => {
  return await del(`${PATH_CLASS}/${classId}/members/${userId}`);
};

export {
  getClasses,
  insertOrUpdateClass,
  deleteClass,
  getClassMembers,
  addStudentToClass,
  removeStudentFromClass,
};
